import React, { useEffect, useState } from "react";
import plus_icon from "../../../common/assets/images/light.png";
import { Dropdown, Table } from "react-bootstrap";
import "../UserManagement/UserManagement.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchUserDetails } from "../../../store/userSlice";
import AddUserModal from "./AddUserModal";
 
const UserManagement = () => {
  const [activeTab, setActiveTab] = useState("All Users");
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  //const userData = useSelector((state) => state.userqueue.userData);
  const dispatch=useDispatch();
  //console.log(userData,'userdata');
  const userData = useSelector((state) => state.userQueue.userData); 
  useEffect(() => {
    // console.log("Dispatching fetchUserDetails...");
    dispatch(fetchUserDetails());
    // console.log("Dispatched fetchUserDetails.");
  }, [dispatch]);
  // console.log(userData,'userdata');
  const tabs = ["All Users", "Coders", "HIMs", "Auditors"];
  return (
    <div>
      <h4 className="speciality-header-text">User Management</h4>
      <div className="user-management-top-wrapper">

     
      <div className="d-flex justify-content-between user-header-wrapper">
        <span style={{ fontSize: "18px", fontWeight: "600" }}>Users</span>
        <div className="d-flex gap-2 align-items-center">
          <input
            type="text"
            placeholder="Search users..."
            className="users-search-input"
          />
          <Dropdown className="config-filter-dropdown">
            <Dropdown.Toggle>{"All Priorities"}</Dropdown.Toggle>
            <Dropdown.Menu>
              {["Urgent", "High", "Low", "Overdue", "Nil assigned"].map(
                (priority) => (
                  <Dropdown.Item>{1}</Dropdown.Item>
                )
              )}
            </Dropdown.Menu>
          </Dropdown>
          <button className="add-user-btn" onClick={() => setIsUserModalOpen(true)}>
            <img src={plus_icon} alt="plus" />
            Add User
          </button>
          <AddUserModal isOpen={isUserModalOpen} onClose={() => setIsUserModalOpen(false)} />
        </div>
      </div>
      <div className="tab-section-wrapper">
      <div className="tab-header">
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`tab-item ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>
    </div>
      <div className="user-management-table">
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Expertise</th>
            <th>Clinical Specialities</th>
            <th>States</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
      </Table>
      </div>
    </div>
    </div>
  );
};

export default UserManagement;
